(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Load only the visible hero video, and pause playback away from the hero.
  const initRoyaHeroVideos = (root = document) => {
    root.querySelectorAll('[data-roya-hero-video]').forEach((video) => {
      if (video.dataset.royaVideoReady) return;
      video.dataset.royaVideoReady = 'true';
      let onScreen = true;
      const breakpoint = window.matchMedia('(max-width: 749px)');
      const sync = () => {
        if (!video.isConnected) {
          breakpoint.removeEventListener('change', sync);
          document.removeEventListener('visibilitychange', sync);
          observer.disconnect();
          return;
        }
        const visible = video.getClientRects().length > 0 && onScreen && !document.hidden;
        if (!visible) { video.pause(); return; }
        const source = video.querySelector('source[data-src]');
        if (source) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          video.load();
        }
        video.muted = true;
        video.play().catch(() => {});
      };
      const observer = new IntersectionObserver((entries) => {
        onScreen = entries[0].isIntersecting;
        sync();
      });
      observer.observe(video);
      breakpoint.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      sync();
    });
  };
  initRoyaHeroVideos();
  document.addEventListener('shopify:section:load', (event) => initRoyaHeroVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
